import { PayloadAction } from '@reduxjs/toolkit'
import isEqual from 'lodash/isEqual'
import isNull from 'lodash/isNull'
import isUndefined from 'lodash/isUndefined'
import { call, select, StrictEffect } from 'redux-saga/effects'

import { hydrateCasingMeshIdsFromOpeningIds } from './data-prep/hydrateMeshIdsFromOpeningIds'
import managers from '../../lib/managers'
import { BabylonManager } from '../../lib/managers/BabylonManager'
import { Highlight } from '../../lib/toolBoxes/3D'
import { IMUPMappingsSelector } from '../../slices/common'
import { ThreeDToTwoDRecord } from '../../types'

export function* getThreeDIdFromOpeningIds(
    mappings: ThreeDToTwoDRecord,
    drawableIds: number[]
): Generator<string[], string[], string[]> {
    return hydrateCasingMeshIdsFromOpeningIds(
        yield Object.keys(mappings).filter((id) => {
            const openingIds = mappings[id] ? mappings[id].flatMap((ids) => ids.openingId) : []

            return drawableIds.some((dId) => openingIds.includes(dId))
        })
    )
}

export function* findMeshIdBasedOnOpeningId(mappings: ThreeDToTwoDRecord, drawableId: number) {
    const meshIDBase: string = yield Object.keys(mappings).find((id) =>
        mappings[id].some((ids) => isEqual(ids.openingId, drawableId))
    )

    return hydrateCasingMeshIdsFromOpeningIds([meshIDBase])
}

export function* handleToggleDrawableOnHover3D(
    action: PayloadAction<{ drawable_id: number }>
): Generator<
    StrictEffect,
    void,
    Highlight & ThreeDToTwoDRecord & string & (BabylonManager | null) & (string | undefined)
> {
    const manager: BabylonManager | null = yield call(managers.get3DManager)

    if (isNull(manager)) return

    const highlightTool: Highlight = yield call(manager.getTool, Highlight.NAME)
    const threeDToTwoDRecord: ThreeDToTwoDRecord = yield select(IMUPMappingsSelector)

    const resultantThreeDId: string | undefined = yield call(
        findMeshIdBasedOnOpeningId,
        threeDToTwoDRecord,
        action.payload.drawable_id
    )

    if (!isUndefined(resultantThreeDId)) {
        yield call(highlightTool.toggleMeshMaterial, resultantThreeDId)
    }
}
